import React from "react";

const TDConversationsHeading = () => {
    return <h4>Conversations</h4>;
};

export default TDConversationsHeading